import React from 'react';
import { RichText } from '../../../../../hoc/components/rich-text';

export interface IReviewItem {
	label: string;
	value: string;
}

const ReviewItem: React.FC<IReviewItem> = ({ label, value }) => {
	return (
		<div className="md:grid gap-4 md:grid-cols-2">
			<dt className="text-font text-lg font-semibold">
				<RichText html={label} />
			</dt>
			<dd className="text-font text-lg break-all whitespace-normal">
				<RichText html={value} />
			</dd>
		</div>
	);
};

export default ReviewItem;
